module.exports = __webpack_public_path__ + "img/vmc_aniv10_24Aug2021.a8afe987.jpg";